import type { ReactElement, ReactNode } from 'react'
import { STATUS_TONE_CLASSES } from './status-tone.ts'
import type { StatusTone } from './status-tone.ts'

/**
 * A status pill: one token triple, and a label that always says the same
 * thing the colour does.
 *
 * `children` is required rather than optional because of the brief's
 * accessibility gate — status must never be carried by colour alone. A
 * bare coloured dot with no adjacent word is unreadable to a deuteranope
 * and invisible to a screen reader, so the type makes it impossible.
 *
 * `StatusChip` is this with a session-status-to-tone map in front of it.
 */

export interface ChipProps {
  tone: StatusTone
  /** The label. Not optional — see above. */
  children: ReactNode
  /** Hover text for the cases where the label had to be abbreviated to fit
   * a 12px table cell. */
  title?: string
}

export function Chip({ tone, children, title }: ChipProps): ReactElement {
  return (
    <span
      title={title}
      className={`inline-block rounded border px-1.5 py-0.5 text-xs font-medium ${STATUS_TONE_CLASSES[tone]}`}
    >
      {children}
    </span>
  )
}
